"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
const InvalidEpoch_1 = __importDefault(require("./Errors/InvalidEpoch"));
class Timestamp {
    constructor(value) {
        this.value = value;
        if (!Number.isInteger(value)) {
            throw new InvalidEpoch_1.default(undefined, 400);
        }
    }
    static now() {
        return new this(Math.floor(Date.now() / 1000));
    }
    subtractSeconds(seconds) {
        if (!Number.isInteger(seconds)) {
            throw new InvalidEpoch_1.default('Expected a number of seconds', 400);
        }
        return new Timestamp(this.value - seconds);
    }
    subtractDays(days) {
        if (!Number.isInteger(days)) {
            throw new InvalidEpoch_1.default('Expected a number of days', 400);
        }
        return this.subtractSeconds(days * Timestamp.SECONDS_IN_ONE_DAY);
    }
}
exports.Timestamp = Timestamp;
Timestamp.SECONDS_IN_ONE_MINUTE = 60;
Timestamp.SECONDS_IN_ONE_HOUR = Timestamp.SECONDS_IN_ONE_MINUTE * 60;
Timestamp.SECONDS_IN_ONE_DAY = Timestamp.SECONDS_IN_ONE_HOUR * 24;
exports.default = Timestamp;
